import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ClientAddressWithCoordinatesComponent } from '@shared/components/catalogs/client-address-with-coordinates/client-address-with-coordinates.component';
import { FormBuilder, Validators } from '@angular/forms';
import { CoordsForm } from '@shared/components/catalogs/client-form/client-form.component';
import { AsyncPipe } from '@angular/common';
import { TuiButtonModule, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { splitLatLong } from '@shared/utils/coords';
import { AddressWithCoordinates } from '../../../../../../types/client';

@Component({
  selector: 'app-custom-location-dialog',
  standalone: true,
  imports: [ClientAddressWithCoordinatesComponent, AsyncPipe, TuiButtonModule],
  templateUrl: './custom-location-dialog.component.html',
  styleUrl: './custom-location-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomLocationDialogComponent {
  addressForm = this.fb.group<CoordsForm>({
    address: this.fb.control(null, Validators.required),
    latLong: this.fb.control(null, Validators.required),
  });

  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    protected readonly context: TuiDialogContext<AddressWithCoordinates, void>,
    private readonly fb: FormBuilder,
  ) {}

  applyLocation() {
    const value = this.addressForm.getRawValue();
    const address: AddressWithCoordinates = {
      address: value.address,
      ...splitLatLong(value.latLong),
    };
    this.context.completeWith(address);
  }
}
